import { AbstractAdapter } from "@app/shared/models/adapter.model";
import { Environment } from "@app/shared/models/environment.model";

export interface Credentials {
  username: string;
  displayName: string;
  isAdmin: boolean;
  isSuper: boolean;
  isHouseAccount: boolean;
  isIdentityAssumed: boolean;
  authenticated2FA: boolean;
  nodeJsAuthentication: NodeJsAuthentication;
}

export interface AssumeIdentity {
  token: string;
  username: string;
  displayName: string;
}

export interface TwoFactorSettings {
  key2FA: string;
  type2FA: number;
  byPass2FA: boolean;
}

export class NodeJsAuthentication {
  accessToken: string;
  refreshToken: string;
}

export class Authentication {
  public credentials: Credentials;
  public token: string;
  public environment: Environment;
  public isPasswordExpired: boolean;
  public avatar: string;
  public rememberMe: boolean;
  public lastLogin: Date | string;
  public isActive: boolean;
  public isHouseAccount: boolean;
  public dontShowAgainIds: string[];
  public _isLoadingAvatar: boolean;
  public twoFactorSettings: TwoFactorSettings;
  public emailAddress: string;

  private DefaultCredentials: Credentials = {
    username: "",
    displayName: "",
    isAdmin: false,
    isSuper: false,
    isHouseAccount: false,
    isIdentityAssumed: false,
    authenticated2FA: false,
    nodeJsAuthentication: {
      accessToken: "",
      refreshToken: ""
    }
  };

  constructor(
    credentials: Credentials,
    token: string,
    environment: Environment,
    isPasswordExpired: boolean,
    avatar: string,
    rememberMe: boolean,
    twoFactorSettings: TwoFactorSettings,
    lastLogin: Date | string,
    emailAddress: string
  ) {
    this.credentials = { ...this.DefaultCredentials, ...credentials };
    this.token = token;
    this.environment = environment;
    this.isPasswordExpired = isPasswordExpired;
    this.avatar = avatar;
    this.rememberMe = rememberMe;
    this.lastLogin = lastLogin;
    this.twoFactorSettings = twoFactorSettings;
    this.dontShowAgainIds = [];
    this._isLoadingAvatar = false;
    this.emailAddress = emailAddress;
  }
}

export class AuthenticationAdapter extends AbstractAdapter<Authentication> {
  adapt(rawData: any): Authentication {
    if (!rawData) {
      return null;
    }

    return new Authentication(
      {
        username: rawData.username.value,
        displayName: this.properCase(rawData.displayName),
        isAdmin: rawData.isAdmin,
        isSuper: rawData.isSuper,
        isHouseAccount: rawData.isHouseAccount,
        isIdentityAssumed: false,
        authenticated2FA: false,
        nodeJsAuthentication: {
          accessToken: "",
          refreshToken: ""
        }
      },
      rawData.token,
      rawData.environment,
      rawData.isPasswordExpired,
      rawData.avatar,
      rawData.rememberMe,
      rawData.twoFactorSettings,
      this.dateService.timeStampToDate(rawData.lastLogin),
      rawData.emailAddress
    );
  }
}

export class AssumeIdentityAdapter extends AbstractAdapter<AssumeIdentity> {
  adapt(rawData: AssumeIdentity): AssumeIdentity {
    rawData.displayName = this.properCase(rawData.displayName);
    return rawData;
  }
}

export interface PortalsPlusJsAuth {
  data: Authentication;
  password: string;
  accessToken: string;
  refreshToken: string;
}

export class PortalsPlusJsAuthAdapter extends AbstractAdapter<PortalsPlusJsAuth> {
  adapt(rawData: PortalsPlusJsAuth): PortalsPlusJsAuth {
    return rawData;
  }
}
